import { createGlobalStyle, css } from 'styled-components';
const DefaultTypography = createGlobalStyle `${css `
	* {
		margin: 0;
		padding: 0;
		outline: none;
		box-sizing: border-box;
		//-webkit-appearance: none;
		-webkit-text-size-adjust: 100%;
		-webkit-font-smoothing: antialiased;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
	}

	ul,
	fieldset {
		list-style: none;
		border: none;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	ul,
	ol,
	blockquote {
		margin-block-start: 0;
		margin-block-end: 0;
		margin-inline-start: 0;
		margin-inline-end: 0;
	}

	button {
		border-width: 0;
		border-color: inherit;
		background-color: inherit;
	}

	a {
		color: unset;
		text-decoration: none;
	}

	svg {
		display: inline-block;
		fill: currentColor;
		line-height: 1;
		stroke: currentColor;
		stroke-width: 0;
	}
`}`;
export default DefaultTypography;
//# sourceMappingURL=typography.js.map